import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../events";

export const FETCH_DELETE_EVENTS_REQUEST = "FETCH_DELETE_EVENTS_REQUEST";
export const FETCH_DELETE_EVENTS_SUCCESS = "FETCH_DELETE_EVENTS_SUCCESS";
export const FETCH_DELETE_EVENTS_FAILURE = "FETCH_DELETE_EVENTS_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDeleteEventsRequest = () => {
  return {
    type: FETCH_DELETE_EVENTS_REQUEST,
  };
};

const fetchDeleteEventsSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DELETE_EVENTS_SUCCESS,
    payload: data,
  };
};

const fetchDeleteEventsFailure = (error: any) => {
  return {
    type: FETCH_DELETE_EVENTS_FAILURE,
    payload: error,
  };
};

export const remove = (id: string) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchDeleteEventsRequest());
    try {
      await Remove(id);
      dispatch(fetchDeleteEventsSuccess(true));
    } catch (error: any) {
      dispatch(fetchDeleteEventsFailure(error.message));
    }
  };
};
